const allDocs = import.meta.glob('../docs/**/*.md', { query: '?raw', eager: true, import: 'default' })

function normalizeKey(locale, section, page) {
  return `../docs/${locale}/${section}/${page}.md`
}

export function getDoc(locale, section, page) {
  const key = normalizeKey(locale, section, page)
  if (allDocs[key] !== undefined) {
    return { content: allDocs[key], locale, fallback: false }
  }

  // Fallback to EN
  if (locale !== 'en') {
    const enKey = normalizeKey('en', section, page)
    if (allDocs[enKey] !== undefined) {
      return { content: allDocs[enKey], locale: 'en', fallback: true }
    }
  }

  return null
}

export function getAllSlugs() {
  return Object.keys(allDocs).map(k => {
    const match = k.match(/\.\.\/docs\/([^/]+)\/([^/]+)\/([^.]+)\.md$/)
    if (!match) return null
    return { locale: match[1], section: match[2], page: match[3] }
  }).filter(Boolean)
}
